import React from 'react';
import RankingWorkspace from '../../components/ranking/RankingWorkspace';

function FavoritesPage() {
  return <RankingWorkspace pageMode="favorite" />;
}

export default FavoritesPage;
